import React, { Component } from 'react';
import FormError from '../../../../models/FormError';
import InputField from '../../../../views/components/InputField.Component';
import ContentModel from '../../models/ContentModel';
import NewsletterSubscriptionFormEntry from '../../models/NewsletterSubscriptionFormEntry';
import NewsletterSubscriptionFormValidationService from '../../services/NewsletterSubscriptionFormValidationService';
import NewsletterSubscriptionService from '../../services/NewsletterSubscriptionService';

declare var dataLayer: any;

type NewsletterSubscriptionFormPageProps = {
    content: ContentModel;
    translatedErrorMessages: any,
}

type NewsletterSubscriptionFormPageState = {
    values: NewsletterSubscriptionFormEntry,
    errors: FormError[],
    subscriptionService: NewsletterSubscriptionService,
    isSubscribed: boolean
}

export default class NewsletterSubscriptionFormPage extends Component<NewsletterSubscriptionFormPageProps, NewsletterSubscriptionFormPageState> {

    public newsletterSubscriptionFormValidator: NewsletterSubscriptionFormValidationService = new NewsletterSubscriptionFormValidationService();

    constructor(props: NewsletterSubscriptionFormPageProps) {
        super(props);

        this.newsletterSubscriptionFormValidator.translatedErrorMessages = props.translatedErrorMessages;

        this.state = {
            values: new NewsletterSubscriptionFormEntry(""),
            errors: [],
            subscriptionService: new NewsletterSubscriptionService(),
            isSubscribed: false,
        };
    }

    private async setValue(propertyName: string, value: string): Promise<FormError[]> {
        let errors: FormError[] = [];
        const values: any = this.state.values;

        if (values.hasOwnProperty(propertyName)) {
            values[propertyName] = value;
            errors = await this.validateProperty(values, propertyName);
        }
        else {
            console.error("Error: property " + propertyName + " was not found on the values and could not be filled in correctly");
        }

        this.setState({
            values: values
        });

        return errors;
    }

    public async sendForm() {

        let errors: FormError[] = await this.newsletterSubscriptionFormValidator.validate(this.state.values);

        this.setState({
            errors: errors
        });

        if (errors.length == 0) {
            const subscribed = await this.state.subscriptionService.subscribe(this.state.values.email);

            if (dataLayer) {
                dataLayer.push({ 'event': 'newsletter-subscription' });
            }

            if (subscribed) {
                this.setState({
                    isSubscribed: subscribed
                });
            }
        }
    }

    public async validateProperty(values: NewsletterSubscriptionFormEntry, propertyName: string): Promise<FormError[]> {
        return this.newsletterSubscriptionFormValidator.validateProperty(values, propertyName);
    }

    public render() {
        return (
            (!this.state.isSubscribed)
                ?
                (<form action="/Newsletter/SubscribeToNewsletter" method="post">
                    <div className="form-group">
                        <InputField id="newsletter-email" autocomplete="email" name="email" label={this.props.content.emailLabel} placeholder={this.props.content.emailPlaceholder} onChange={this.setValue.bind(this)}></InputField>
                    </div>
                    <button className="btn btn-primary btn-block boxshadow-25" type="button" onClick={() => { this.sendForm(); }}>{this.props.content.buttonText}</button>
                    <div className="d-flex justify-content-center pt-2 mt-2 mt-md-4 mt-lg-2 mb-3 mb-md-0">
                        <a className="font-weight-bold text-center text-medium" href={this.props.content.linkTargetPage}>
                            {this.props.content.linkText}
                        </a>
                    </div>
                </form>)
                :
                (<div className="pt-3">
                    <div className="h6 mb-3">
                        {this.props.content.succesMessageTitle}
                    </div>
                    <p className="text-medium">
                        {this.props.content.succesMessage}
                    </p>
                </div>)
        );
    }
}